import { LayoutStandardPage } from "../layout/LayoutStandardPage"
import { PartialContactPage } from "../layout/Partial/PartialContactPage";

export const ContactPage = () => {

    return(
        <LayoutStandardPage component={PartialContactPage.toString()} />
    )
}